import { useMutation } from '@tanstack/react-query'
import { useAuth0 } from '@auth0/auth0-react'
import { getAPIAccessToken } from '../lib/auth0'
import { apiClients } from '../lib/apiClient'

type ExecutePaymentClient = (typeof apiClients)['/api/stripe/create-checkout-session']['POST']['client']

export const useCreateCheckoutSession = () => {
  const { getAccessTokenSilently, getAccessTokenWithPopup } = useAuth0()

  return useMutation<
    Awaited<ReturnType<ExecutePaymentClient>>['body'],
    { returnUrl: string | null },
    Parameters<ExecutePaymentClient>[0]['body']
  >({
    mutationFn: async (args) => {
      const token = await getAPIAccessToken(getAccessTokenSilently, getAccessTokenWithPopup)

      const res = await apiClients['/api/stripe/create-checkout-session'].POST.client({
        headers: {
          Authorization: `Bearer ${token}`
        },
        body: args
      })

      if (!res.ok) {
        return Promise.reject()
      }
      return res.body
    }
  })
}
